// Types
import type { TTableHeaders } from '~/misc/v-table/types';

const TABLE_HEADERS: TTableHeaders = [
  'Type',
  'Is Market Appraisal?',
  'Description',
  'Created At',
  'Updated At',
];

export { TABLE_HEADERS };
